(function () {
    'use strict';

    a3_pilot_reports.directive('sectorHistory', sectorHistory);
    /**
    * @memberof PilotReports
    * @ngdoc directive
    * @name sectorHistory
    * @restrict E
    * @description
    *    Implementation of sector history
    * @example
    *   Usage:
    *   <sector-history></sector-history>
    * @ngInject
    */
    function sectorHistory() {
        function link(scope, element, attrs) {
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/TrainingReadOnly/sector-history.tpl.html',
            scope: {history : "="},
            link: link
        }
    }

})();
